import React from 'react';

export function CollapsedTopicSkeleton() {
  return (
    <div className="animate-pulse flex flex-col items-center gap-4 py-4">
      {/* Create an array of 5 skeleton items */}
      {[...Array(5)].map((_, index) => (
        <div key={index} className="w-8 h-8 rounded-lg bg-gray-100" />
      ))}
    </div>
  );
}
